import { render, staticRenderFns } from "./bids.vue?vue&type=template&id=aa4ad4f2&"
import script from "./bids.vue?vue&type=script&lang=js&"
export * from "./bids.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports